import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { ModuleContentTooltip } from 'components/Common/MUIStyledComponents';
import TarrifTypes from './TarrifTypes';
import TarrifResults from './TarrifResults';
import ResultsTable from './table/ResultsTable';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

interface ITariffSearchProps {
  inputs: any;
  setInputs: any;
  handleSubmit: any;
  results: any;
  page: number;
  setPage: any;
  userHasSearch: boolean;
  handleMultiPageChange?: any;
  handleClear?: any;
  createTicket?: any;
  saving?: boolean;
  setShowFullRecord: any;
}

const TariffSearch: React.FC<ITariffSearchProps> = ({ userHasSearch, setPage, page, inputs, setInputs, handleSubmit, results, createTicket, saving, setShowFullRecord }) => {
  const handleClearInput = (field: any) => {
    const onChangeValue = { ...inputs };
    onChangeValue[field] = '';
    setInputs(onChangeValue);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const onChangeValue = { ...inputs };
    onChangeValue[name] = value;
    setInputs(onChangeValue);
  };

  return (
    <div className={`screening-search-container-full ${!userHasSearch ? 'os-iframe-blur' : ''}`}>
      <div className='screening-inputs-list'>
        <div className='screening-input-row'>
          <div className='screening-label-input'>
            <div style={{ width: '-webkit-fill-available' }}>


              <div className='screening-input-group' style={{ marginTop: 0 }}>
                <div className='screening-input-minors'>
                  <div className='screening-input-field-container' style={{ width: '35%' }}>
                    <input
                      id='htsCode'
                      type='text'
                      placeholder='Required: Enter HTS Code'
                      className='screening-input-field-content'
                      name='htsCode'
                      value={inputs.htsCode}
                      onChange={(e) => handleChange(e)}
                    />
                    <svg onClick={() => handleClearInput('htsCode')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                  <div className='screening-input-field-container' style={{ width: '65%' }}>
                    <input
                      id='originCountry'
                      type='text'
                      placeholder='Required: Enter Country of Origin'
                      className='screening-input-field-content'
                      name='originCountry'
                      value={inputs.originCountry}
                      onChange={(e) => handleChange(e)}
                    />
                    <svg onClick={() => handleClearInput('originCountry')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='screening-filters-cont'>
        <div className='screening-filters-group'>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: 'auto' }}>
            <ModuleContentTooltip
              title={
                <p className='module-header-tooltip-text'>
                    Enter an HTS Code and Country of Origin and let BITE&apos;s AI tell you exactly what Tariffs apply to your transaction and what they cost you.<br/> If you do not know your HTS Code you may use our <Link to='/bite-classify'>
                    <Button sx={{ color: '#4895EF', padding: 0 }}>BITE Classify Tool</Button>
                  </Link>
                </p>
              }
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    'display': 'flex',
                    'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    'flexDirection': 'column',
                    'alignItems': 'flex-start',
                    'alignSelf': 'stretch',
                    'borderRadius': 'var(--radius-md, 8px)',
                    'background': 'var(--Background-200, #202227)',
                    'maxWidth': '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, #202227)'
                    }
                  },
                },
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                <path d='M9 8.25C8.80109 8.25 8.61033 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61033 12.671 8.80109 12.75 9 12.75C9.19892 12.75 9.38968 12.671 9.53033 12.5303C9.67099 12.3897 9.75 12.1989 9.75 12V9C9.75 8.80109 9.67099 8.61032 9.53033 8.46967C9.38968 8.32902 9.19892 8.25 9 8.25ZM9.285 5.31C9.10241 5.23499 8.8976 5.23499 8.715 5.31C8.62294 5.3457 8.53883 5.39922 8.4675 5.4675C8.40126 5.5404 8.34799 5.62411 8.31 5.715C8.26802 5.80401 8.24747 5.90162 8.25 6C8.24943 6.0987 8.26835 6.19655 8.30568 6.28793C8.343 6.37931 8.39799 6.46242 8.4675 6.5325C8.5404 6.59875 8.62412 6.65202 8.715 6.69C8.82863 6.73668 8.95198 6.75474 9.07421 6.74258C9.19645 6.73043 9.31383 6.68844 9.41604 6.6203C9.51825 6.55216 9.60215 6.45996 9.66039 6.3518C9.71862 6.24364 9.74939 6.12284 9.75 6C9.74724 5.80142 9.66955 5.61123 9.5325 5.4675C9.46118 5.39922 9.37707 5.3457 9.285 5.31ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z' fill='#F5FAFF'/>
              </svg>
            </ModuleContentTooltip>
            <div className='screening-input-submit-group'>
              <button className='btn-new-automate' onClick={() => handleSubmit(page)}>
                <div>Run Screen</div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', width: '100%' }}>
        <div className='api-container-left'>
          <TarrifTypes/>
        </div>
        <div className='api-container-right'>
          <div className='results-card-frames'>
            <TarrifResults/>
          </div>
        </div>
      </div>
      {results.isLoading && (
        <div>
          <CircularProgress style={{ color: '#0E8BFF' }} />
        </div>
      )}
      {!results.isLoading && (
        <ResultsTable
          setShowFullRecord={setShowFullRecord}
          handleSubmit={handleSubmit}
          setPage={setPage}
          page={page}
          results={results}
        />
      )}
    </div>
  );
};

export default TariffSearch;
